/**
 * Placeholder shown while a lazily-loaded route or module page is still being
 * fetched (request 0194). Deliberately the same markup `ModuleEntry` already
 * used while module resolution was in flight, so the two waits look identical
 * to the user instead of one flashing a different shape than the other.
 */
export function RouteFallback() {
  return (
    <div className="flex h-full items-center justify-center text-sm text-fg-muted">
      Carregando…
    </div>
  )
}
